import React from 'react'

export default function Footer () {
    const style = {
        footer: {
            backgroundColor: "#0b486b",
            color: "white",
            height: "6vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }
    return (
        <div style={style.footer}>
            ©2020 Michael Ip
        </div>
    )
}